/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

const MedicationSuggestionIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2961 8.84667L14.1161 12.6667L13.1227 13.66L9.30272 9.84C8.58939 10.3533 7.72939 10.6667 6.78939 10.6667C4.39605 10.6667 2.45605 8.72667 2.45605 6.33333C2.45605 3.94 4.39605 2 6.78939 2C9.18272 2 11.1227 3.94 11.1227 6.33333C11.1227 7.27333 10.8094 8.13333 10.2961 8.84667ZM6.78939 3.33333C5.12939 3.33333 3.78939 4.67333 3.78939 6.33333C3.78939 7.99333 5.12939 9.33333 6.78939 9.33333C8.44939 9.33333 9.78939 7.99333 9.78939 6.33333C9.78939 4.67333 8.44939 3.33333 6.78939 3.33333Z"
      fill="#4D4D4D"
    />
  </svg>
);
export default MedicationSuggestionIcon;
